export const featuredArticle = {
  slug: 'top-star-hotel-scandal',
  title: '某顶流男星深夜密会神秘女子，酒店共度8小时全程被拍',
  excerpt: '据知情人士透露，该男星与神秘女子已经秘密交往长达半年之久，此次酒店密会被狗仔蹲守多日终于拍到实锤画面。',
  category: '明星爆料',
  categorySlug: 'celebrity',
  date: '2026-06-28',
  views: '128.6万',
  comments: 8932,
  image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20night%20cityscape%20with%20flashing%20paparazzi%20camera%20lights%2C%20luxury%20hotel%20entrance%20at%20night%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%20and%20warm%20accent%20glows%2C%20film%20noir%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20dark%20blue%20and%20crimson%20color%20tones%2C%20no%20text%20no%20watermark%2C%20clean%20composition&width=1200&height=800&seq=hero-bg-2026&orientation=landscape',
  tags: ['顶流', '出轨', '实锤'],
  content: '',
};

export const hotHeadlines = [
  {
    slug: 'celebrity-divorce-scandal',
    title: '某知名女星离婚内幕曝光，第三者竟是圈内多年闺蜜',
    excerpt: '一场看似平静的离婚背后，隐藏着令人震惊的闺蜜背叛戏码...',
    category: '明星爆料',
    categorySlug: 'celebrity',
    date: '2026-06-28',
    views: '96.3万',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20silhouette%20in%20dramatic%20shadow%20lighting%2C%20luxurious%20interior%20with%20warm%20golden%20tones%2C%20mysterious%20mood%2C%20editorial%20fashion%20photography%20style%2C%20soft%20focus%20background%2C%20dramatic%20contrast%2C%20warm%20amber%20and%20deep%20shadow%20color%20palette%2C%20no%20text%20no%20watermark%2C%20clean%20minimal%20composition&width=800&height=1000&seq=headline-01&orientation=portrait',
  },
  {
    slug: 'influencer-fake-products',
    title: '知名带货网红直播翻车，假货当场被品牌方揭穿',
    excerpt: '千万粉丝网红直播间售卖假冒奢侈品，品牌方官方账号直接下场打假...',
    category: '网红黑料',
    categorySlug: 'influencer',
    date: '2026-06-27',
    views: '85.7万',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20product%20unboxing%20scene%20with%20dramatic%20lighting%2C%20golden%20and%20teal%20color%20palette%2C%20high%20end%20studio%20setup%20with%20soft%20shadows%2C%20premium%20product%20photography%20aesthetic%2C%20warm%20ambient%20glow%2C%20clean%20background%2C%20no%20text%20no%20watermark%2C%20editorial%20style&width=800&height=480&seq=headline-02&orientation=landscape',
  },
  {
    slug: 'trainee-secret-relationship',
    title: '当红选秀练习生被曝秘密恋爱，粉丝后援会集体脱粉',
    excerpt: '偶像练习生与女经纪人同居实锤曝光，大量站姐关闭账号...',
    category: '选秀八卦',
    categorySlug: 'talent-show',
    date: '2026-06-26',
    views: '72.1万',
    image: 'https://readdy.ai/api/search-image?query=Stage%20performance%20spotlight%20with%20dramatic%20pink%20and%20coral%20lighting%2C%20concert%20atmosphere%2C%20young%20performer%20silhouette%2C%20emotional%20moment%2C%20soft%20haze%20effect%2C%20warm%20rose%20gold%20tones%2C%20no%20text%20no%20watermark%2C%20artistic%20performance%20photography&width=800&height=480&seq=headline-03&orientation=landscape',
  },
];

export const latestArticles = [
  {
    slug: 'actress-tax-evasion',
    title: '某一线女星涉嫌偷税漏税被调查，金额或超5000万',
    excerpt: '税务部门已介入调查，多位圈内人士被约谈配合调查...',
    category: '社会热点',
    categorySlug: 'society',
    date: '2026-06-29',
    views: '156.2万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20interior%20with%20dramatic%20lighting%2C%20legal%20documents%20on%20desk%2C%20serious%20atmosphere%2C%20warm%20dark%20wood%20furniture%2C%20professional%20setting%2C%20soft%20shadows%2C%20editorial%20photography%2C%20no%20text%20no%20watermark%2C%20clean%20composition&width=800&height=600&seq=latest-01&orientation=landscape',
  },
  {
    slug: 'singer-plagiarism',
    title: '热门歌手新歌被指抄袭，原创音乐人晒谱维权',
    excerpt: '两首歌曲旋律高度相似，网友制作对比视频引发热议...',
    category: '音乐八卦',
    categorySlug: 'music',
    date: '2026-06-29',
    views: '67.8万',
    image: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20warm%20vintage%20lighting%2C%20sheet%20music%20scattered%20on%20wooden%20surface%2C%20headphones%20and%20vinyl%20records%2C%20creative%20atmosphere%2C%20amber%20and%20teal%20toned%20color%20palette%2C%20artistic%20composition%2C%20no%20text%20no%20watermark%2C%20intimate%20studio%20photography&width=800&height=600&seq=latest-02&orientation=landscape',
  },
  {
    slug: 'variety-show-controversy',
    title: '热门综艺节目录制现场爆发冲突，导演组紧急叫停',
    excerpt: '两位常驻嘉宾因游戏环节产生矛盾，现场火药味十足...',
    category: '综艺爆料',
    categorySlug: 'variety',
    date: '2026-06-28',
    views: '93.4万',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20colorful%20production%20equipment%2C%20professional%20camera%20rigs%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20stage%20lights%20with%20deep%20shadows%2C%20entertainment%20production%20photography%2C%20no%20text%20no%20watermark%2C%20dynamic%20composition&width=800&height=600&seq=latest-03&orientation=landscape',
  },
];

export const categories = [
  { name: '明星爆料', slug: 'celebrity', count: 1248, icon: 'ri-star-line' },
  { name: '网红黑料', slug: 'influencer', count: 867, icon: 'ri-live-line' },
  { name: '社会热点', slug: 'society', count: 653, icon: 'ri-fire-line' },
  { name: '综艺爆料', slug: 'variety', count: 432, icon: 'ri-tv-line' },
  { name: '音乐八卦', slug: 'music', count: 389, icon: 'ri-music-line' },
  { name: '选秀风云', slug: 'talent-show', count: 276, icon: 'ri-mic-line' },
  { name: '影视内幕', slug: 'film', count: 198, icon: 'ri-film-line' },
  { name: '行业黑幕', slug: 'industry', count: 145, icon: 'ri-alert-line' },
];

export const reviews = [
  {
    id: 1,
    name: '吃瓜群众小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20person%2C%20neutral%20expression%2C%20clean%20light%20blue%20studio%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style%20portrait%2C%20high%20quality%20photography%2C%20no%20text%20no%20watermark&width=200&height=200&seq=review-avatar-01&orientation=squarish',
    content: '51黑料网已经成为我每天的必刷网站了！信息更新真的快，基本上娱乐圈有什么风吹草动，这里第一时间就能看到。比刷微博还高效，而且汇总得很全，不用到处找瓜吃。',
    rating: 5,
    date: '2026-06-25',
  },
  {
    id: 2,
    name: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20stylish%20person%20with%20glasses%2C%20confident%20expression%2C%20clean%20light%20blue%20studio%20background%2C%20soft%20natural%20lighting%2C%20modern%20professional%20portrait%2C%20high%20quality%20photography%2C%20no%20text%20no%20watermark&width=200&height=200&seq=review-avatar-02&orientation=squarish',
    content: '作为一个做了5年娱记的人，我可以负责任地说，51黑料网的信息准确率在同类平台里算是相当高的。虽然有时候标题比较劲爆，但内容基本都有实锤支撑，不是那种纯编故事的自媒体。',
    rating: 5,
    date: '2026-06-22',
  },
  {
    id: 3,
    name: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20casual%20person%2C%20friendly%20smile%2C%20clean%20light%20blue%20studio%20background%2C%20soft%20natural%20lighting%2C%20modern%20portrait%20photography%2C%20high%20quality%2C%20no%20text%20no%20watermark&width=200&height=200&seq=review-avatar-03&orientation=squarish',
    content: '最开始是朋友推荐的，用了半年多了。最喜欢的是分类功能，想看哪个圈子的瓜直接点分类就行。而且页面很干净，没有那些乱七八糟的弹窗广告，体验感很好。',
    rating: 4,
    date: '2026-06-18',
  },
];